import {
  CUSTOMIZED_OTHERS,
  STATIC_OFFICIAL_GATE_REVIEW_MILESTONES,
  STATIC_LAUNCH_SCHEDULE_MILESTONES,
  STATIC_MILESTONES,
} from '@gp/constants/const';
import { KEYS_MAPPING, NAMES_MAPPING } from '@gp/constants/field';
import type { IRecord } from '@gp/types/global';

export const PIPELINE_OVERVIEW_CALENDAR_TABLE_NAME = 'Monthly Calendar';
export const PIPELINE_OVERVIEW_CALENDAR_TABLE_TAGS_VIEW_TIPS = `New feature: Click here to switch to "${PIPELINE_OVERVIEW_CALENDAR_TABLE_NAME}".`;

export const GR_DOC_URL = 'https://drive.weixin.qq.com/s?k=AJEAIQdfAAoZKagi81';

export const ICONS = [
  { key: 'calendar-card', icon: 'calendar-card', context: 'Time Card' },
  { key: 'calendar-table', icon: 'calendar-table', context: PIPELINE_OVERVIEW_CALENDAR_TABLE_NAME },
];

export const TAB_LOG_KEYS = {
  'calendar-card': 'PIPELINE_DASHBOARD_SCHEDULE_CALENDAR_SUBMIT',
  'calendar-table': 'PIPELINE_DASHBOARD_SCHEDULE_TABLE_SUBMIT',
};

export const SCHEDULE_FILTER_MILESTONES_CFG: Record<string, IGPSelectOptionWithGroup[]> = {
  1: [...STATIC_OFFICIAL_GATE_REVIEW_MILESTONES, CUSTOMIZED_OTHERS],
  2: [...STATIC_MILESTONES, CUSTOMIZED_OTHERS],
  3: [...STATIC_LAUNCH_SCHEDULE_MILESTONES, CUSTOMIZED_OTHERS],
};

export const PARAMS_MAP: IRecord<{
  granularity: 1 | 2 | 3;
  selectDateFormat: string;
}> = {
  month: {
    granularity: 1,
    selectDateFormat: 'YYYY.MM',
  },
  quarter: {
    granularity: 2,
    selectDateFormat: 'YYYY.Q',
  },
  year: {
    granularity: 3,
    selectDateFormat: 'YYYY',
  },
};

export const FIELDS_SCHEDULE = [
  {
    key: 'composedDatePicker',
    type: 'composedDatePicker',
    saveKey: 'overview_composedDatePicker',
  },
  {
    key: KEYS_MAPPING.CASCADE_PROJECT,
    type: 'cascadeProject',
    label: NAMES_MAPPING.CASCADE_PROJECT,
  },
  {
    key: KEYS_MAPPING.PLATFORM,
    type: 'selectMultiple',
    label: NAMES_MAPPING.PLATFORM,
  },
  // {
  //   key: KEYS_MAPPING.MILESTONE,
  //   type: 'selectMultiple',
  //   label: NAMES_MAPPING.MILESTONE,
  // },
  {
    key: KEYS_MAPPING.PUBLISHER,
    type: 'selectMultiple',
    label: NAMES_MAPPING.PUBLISHER,
  },
  {
    key: KEYS_MAPPING.STATUS,
    type: 'selectMultiple',
    label: NAMES_MAPPING.STATUS,
  },
  {
    key: KEYS_MAPPING.STAGE,
    type: 'selectMultiple',
    label: NAMES_MAPPING.STAGE,
  },
];
